import CheckOutlined from '@ant-design/icons/CheckOutlined'
import CloseOutlined from '@ant-design/icons/CloseOutlined'
import { Button } from 'antd'
import { FC } from 'react'
import styled from 'styled-components'

interface BooleanInputProps {
  onAnswer: (value: boolean) => void
  disabled?: boolean
}

export const BooleanInput: FC<BooleanInputProps> = ({ onAnswer, disabled }) => {
  return (
    <ButtonContainer>
      <StyledButton
        type='primary'
        size='large'
        icon={<CheckOutlined />}
        onClick={() => onAnswer(true)}
        disabled={disabled}
        $variant='yes'>
        Yes
      </StyledButton>
      <StyledButton
        type='primary'
        size='large'
        icon={<CloseOutlined />}
        onClick={() => onAnswer(false)}
        disabled={disabled}
        $variant='no'>
        No
      </StyledButton>
    </ButtonContainer>
  )
}

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
`

const StyledButton = styled(Button)<{ $variant: 'yes' | 'no' }>`
  min-width: 120px;
  height: 48px;
  font-size: 16px;
  font-weight: 600;

  &.ant-btn-primary {
    background-color: ${({ $variant }) =>
      $variant === 'yes' ? '#52c41a' : '#ff4d4f'};
    border-color: ${({ $variant }) =>
      $variant === 'yes' ? '#52c41a' : '#ff4d4f'};

    &:hover:not(:disabled) {
      background-color: ${({ $variant }) =>
        $variant === 'yes' ? '#73d13d' : '#ff7875'};
      border-color: ${({ $variant }) =>
        $variant === 'yes' ? '#73d13d' : '#ff7875'};
    }
  }
`
